export const messages = {
  en: {
    order: {
      productNamePlaceholder: 'Enter product name',
      userNamePlaceholder: 'Enter user name',
      buyerPlaceholder: 'Enter buyer name',
      order: {
        title: 'Orders',
        no: 'Order No',
        platform: 'Platform',
        shop: 'Shop',
        type: 'Type',
        typeOptions: {
          product: 'Product',
          service: 'Service'
        },
        name: 'Name',
        quantity: 'Quantity',
        userName: 'User Name',
        amount: 'Amount',
        status: 'Status',
        createTime: 'Create Time'
      },
      refundOrder: {
        title: 'Refund Orders',
        productName: 'Product Name',
        spec: 'Specification',
        refundAmount: 'Refund Amount',
        reason: 'Reason',
        applyTime: 'Apply Time'
      },
      groupOrder: {
        title: 'Group Orders',
        id: 'Order ID',
        image: 'Product Image',
        name: 'Product Name',
        buyer: 'Buyer',
        leader: 'Group Leader',
        quantity: 'Quantity',
        people: 'Group People',
        price: 'Group Price',
        status: 'Status',
        rebate: 'Rebate Amount',
        startTime: 'Start Time',
        groupTime: 'Group Time',
        endTime: 'End Time'
      },
      refundGroupOrder: {
        title: 'Group Refund Orders',
        shop: 'Shop',
        refundNo: 'Refund No',
        order: 'Order',
        product: 'Product',
        buyer: 'Buyer',
        quantity: 'Quantity',
        price: 'Group Price',
        refundAmount: 'Refund Amount',
        type: 'Refund Type',
        typeOptions: {
          self: 'Self Refund',
          failed: 'Group Failed Refund'
        },
        reason: 'Reason',
        status: 'Status',
        remark: 'Audit Remark'
      },
      seckillOrder: {
        title: 'Seckill Orders',
        shop: 'Shop',
        id: 'Order ID',
        image: 'Product Image',
        name: 'Product Name',
        buyer: 'Buyer',
        quantity: 'Quantity',
        price: 'Seckill Price',
        time: 'Purchase Time',
        status: 'Status',
        statusOptions: {
          pending: 'Pending Payment',
          completed: 'Completed'
        },
        endTime: 'Deadline'
      }
    }
  },
  zh: {
    order: {
      productNamePlaceholder: '请输入商品名称',
      userNamePlaceholder: '请输入用户名称',
      buyerPlaceholder: '请输入购买者',
      order: {
        title: '订单管理',
        no: '订单号',
        platform: '平台',
        shop: '商铺',
        type: '类型',
        typeOptions: {
          product: '商品',
          service: '服务'
        },
        name: '名称',
        quantity: '数量',
        userName: '用户名称',
        amount: '支付金额',
        status: '订单状态',
        createTime: '创建时间'
      },
      refundOrder: {
        title: '退货订单',
        productName: '商品名称',
        spec: '商品规格',
        refundAmount: '退款金额',
        reason: '退款原因',
        applyTime: '申请时间'
      },
      groupOrder: {
        title: '拼团订单',
        id: '订单ID',
        image: '商品图片',
        name: '商品名称',
        buyer: '购买者',
        leader: '团长',
        quantity: '购买数量',
        people: '拼团人数',
        price: '拼团金额',
        status: '状态',
        rebate: '返佣金额',
        startTime: '开团时间',
        groupTime: '拼团时间',
        endTime: '截止时间'
      },
      refundGroupOrder: {
        title: '拼团退单',
        shop: '店铺',
        refundNo: '退单编号',
        order: '订单',
        product: '商品',
        buyer: '购买人',
        quantity: '购买数量',
        price: '拼团价格',
        refundAmount: '退款金额',
        type: '退款类型',
        typeOptions: {
          self: '自主退款',
          failed: '拼团失败退款'
        },
        reason: '退款原因',
        status: '状态',
        remark: '审核说明'
      },
      seckillOrder: {
        title: '秒杀订单',
        shop: '店铺',
        id: '订单ID',
        image: '商品图片',
        name: '商品名称',
        buyer: '购买者',
        quantity: '购买数量',
        price: '秒杀金额',
        time: '购买时间',
        status: '状态',
        statusOptions: {
          pending: '待支付',
          completed: '完成'
        },
        endTime: '截止时间'
      }
    }
  }
}